<script setup>
defineProps({
  col: {
    type: Boolean,
    default: false
  },
  cols: {
    type: [Number, String]
  },
  sm: {
    type: [Number, String]
  },
  md: {
    type: [Number, String]
  },
  lg: {
    type: [Number, String]
  },
  xl: {
    type: [Number, String]
  },
  // note the offset-${size} and order-${size} props could be implemented here, but at the time I created this component, nothing in our app used them
  offset: {
    type: [Number, String]
  },
  order: {
    type: [Number, String]
  },
  alignSelf: {
    type: [String]
  }
})
</script>

<template>
  <div
    :class="[
      {
        col: col || !cols,
        [`col-${cols}`]: cols,
        [`col-sm-${sm}`]: sm,
        [`col-md-${md}`]: md,
        [`col-lg-${lg}`]: lg,
        [`col-xl-${xl}`]: xl,
        [`offset-${offset}`]: offset,
        [`order-${order}`]: order,
        [`align-self-${alignSelf}`]: alignSelf
      }
    ]"
  >
    <slot></slot>
  </div>
</template>
